import { useTranslation } from "react-i18next";
import { FaExclamationTriangle, FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import ReusableModal from "../../../shared/ReuseableModal";
import CustomButton from "../../../shared/CustomButton";
import { patientDetailsList } from "../../../constants/BeneficiaryConstants";
import ListDetailsCard from "../../../shared/ListDetailsCard";

const PatientRecordSummaryModal = ({
  isVisible,
  onClose,
  recordData,
  onConfirm,
  isLoading,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!recordData) return null;

  const { patient } = recordData;

  const handleUpdatePatient = () => {
    onClose();
    navigate("/edit-beneficiary", {
      state: {
        beneficiaryDetails: patient,
        patientData: patient,
        patient_id: patient?.patient_id,
      },
    });
  };

  return (
    <ReusableModal
      className="w-full md:!w-[90%] xl:!w-[80%]"
      position="top"
      HeaderIcon={FaExclamationTriangle}
      title={t("Patient Already Exists")}
      isVisible={isVisible}
      onClose={onClose}
    >
      <div className="p-2">
        <div className="bg-yellow-50 border-l-4 rounded-lg border-yellow-400 p-3 mb-2">
          <div className="flex">
            <div className="flex-shrink-0">
              <FaExclamationTriangle className="h-5 w-5 text-yellow-400" />
            </div>
            <div className="ltr:ml-3 rtl:mr-3">
              <p className="text-[14px] text-yellow-700">
                {t("This patient is already registered in the system and has active records. Please update the patient information.")}
              </p>
            </div>
          </div>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-2">{t("Patient Information")}</h3>
          <ListDetailsCard listData={patientDetailsList(patient, t)} />
        </div>

        {/* <div className="flex justify-end gap-2 mt-4">
          <CustomButton
            type="button"
            onClick={onClose}
            buttonType="reset"
            icon="pi pi-times"
            disabled={isLoading}
          >
            {t("Cancel")}
          </CustomButton>
          <CustomButton
            type="button"
            onClick={handleUpdatePatient}
            variant="primary"
            icon={<FaEdit size={17} className="me-2" />}
            disabled={isLoading}
          >
            {t("Update Patient")}
          </CustomButton>
        </div> */}
      </div>
    </ReusableModal>
  );
};

export default PatientRecordSummaryModal;
